import { createAsyncThunk } from '@reduxjs/toolkit';

import { authService } from 'services';
import { Credentials } from 'interfaces';
import axios from 'axios';

export const signUp = createAsyncThunk<void, Credentials>(
  'auth/signUp',
  async (credentials, { rejectWithValue }) => {
    try {
      const { accessToken, refreshToken } = await authService.signUp(
        credentials
      );

      localStorage.setItem('accessToken', `Bearer ${accessToken}`);
      localStorage.setItem('refreshToken', refreshToken);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (Array.isArray(err.response.data))
          return rejectWithValue(err.response.data[0].messages.join());

        return rejectWithValue(err.response.data.message);
      }
      if (err instanceof Error) {
        return rejectWithValue(err.message);
      }
      return rejectWithValue(err);
    }
  }
);
